import { MAX_TO } from '@vy/types';
import { formatNumber } from '@vy/utils';
import { INFINITY_SYMBOL } from '../../../../../../../assets/components/design/symbols/infinity-symbol';

export function getToDisplayValue(value: number) {
  return value === MAX_TO ? INFINITY_SYMBOL : formatNumber(value);
}
